import { NgModule } from '@angular/core';
import { ChevronLeftComponent } from '~shared/svgs/chevron-left/chevron-left.component';

@NgModule({
  declarations: [
    ChevronLeftComponent
  ],
  exports: [
    ChevronLeftComponent
  ]
})
export class ChevronLeftModule {}
